<template>
	<div class="min">
		<!--个人信息 -->
		<div class="top" style="position: fixed; width: 100%; top: 1.6875rem; z-index: 9;">
			<img v-if="userInfo.image == null" src="../../assets/user.png" alt="">
			<img v-else :src="userInfo.image | handleUrl" alt="" @click="getImg(userInfo.image)">
			<div class="top-center">
				<div class="name">
					<div>{{userInfo.username}}&nbsp;</div>
					<div class="name-vip">
						<img src="../../assets/vip.png" alt="">
						<div v-if="userInfo.vip_state===0">非会员</div>
						<div v-else>会员</div>
					</div>
				</div>
				<div class="tel">编号&nbsp;{{userInfo.user_num}}</div>
			</div>
			<div class="top-right">
				<div @click="weidu">
					<!-- 未读消息 -->
					<div class="weidu" v-if="newxiaoxi==true">

					</div>
					<van-icon name="volume-o" size="1rem" />
					<router-link to="/xiaoxi">
						<span>消息</span>
					</router-link>
				</div>
				<div @click="open53">
					<van-icon name="service-o" size="1rem" />
					<span>客服</span>
				</div>
			</div>
		</div>
		<div class="column" style="position: fixed; top: 5.6875rem; width: 100%; z-index: 9;">
			<div class="border-rt" @click="to('/wallet')">
				<!-- @click="to('/wallet')" -->
				<span>我的钱包</span>
				<p>{{userInfo.total}}</p>
			</div>
			<div class="border-rt" @click="to('/browsinghistory')">
				<!-- '/record' -->
				<span>浏览记录</span>
				<p v-if="browse != undefined">{{browse}}</p>
				<p v-else>0</p>
			</div>
			<div @click="to('/collect')">
				<span>收藏</span>
				<p>{{userInfoo.collection}}</p>
			</div>
		</div>
		<div class="menu-vip" v-if="userInfo.vip_state===0" style="margin-top: 8.375rem;">
			<div>
				<img src="../../assets/vip.png" alt="">
				<div>开通会员，享受全国最低价</div>
			</div>
			<div class="btn" @click="show=true">立即开通</div>
		</div>
		<!-- 订单菜单 -->
		<div class="menu" >
			<div class="container">
				<div class="menu-top">
					<div class="menu-top-header">
						<van-cell title="我的订单" class="menu-btn" is-link value="查看全部订单" to="/order" />
						<div v-if="order.length == 0"></div>
						<div class="list" v-else>
							<div @click="to('/order', '0')">
								<van-icon name="paid" size="1.7rem" />
								<p>待支付</p>
								<span v-if="order.to_be_dfk != 0">{{order.to_be_dfk}}</span>
							</div>
							<div @click="to('/order', '1')">
								<van-icon name="logistics" size="1.7rem" />
								<p>待发货</p>
								<span v-if="order.to_be_dfh != 0">{{order.to_be_dfh}}</span>
							</div>
							<div @click="to('/order', '2')">
								<van-icon name="gift-o" size="1.7rem" />
								<p>待收货</p>
								<span v-if="order.to_be_dsh != 0">{{order.to_be_dsh}}</span>
							</div>
							<div @click="to('/order', '3')">
								<van-icon name="good-job-o" size="1.7rem" />
								<p>待点评</p>
								<span v-if="order.to_be_dpj != 0">{{order.to_be_dpj}}</span>
							</div>
							<div @click="to('/aftersale','4')">
								<!-- 未开通功能的事件 notice -->
								<van-icon name="service-o" size="1.5rem" />
								<p>售后服务</p>
							</div>
						</div>
					</div>
					<div class="xxdd">
						<van-cell title="线下订单" icon="notes-o" is-link to="OffList">
							<div slot="icon" class="icon_img">
								<img src="../../assets/order.png" alt="">
							</div>
							<div v-if="number != ''">您有<span style="color: red; font-weight: bold;">{{number}}</span>条未支付订单</div>
						</van-cell>
						<van-cell title="整租订单" icon="notes-o" is-link to="wholeList">
							<div slot="icon" class="icon_img">
								<img src="../../assets/min_whole.png" alt="">
							</div>
						</van-cell>
					</div>
					<div class="center">
						<van-cell title="我的闲具" icon="hotel-o" is-link to="/idle">
							<div slot="icon" class="icon_img">
								<img src="../../assets/about.png" alt="">
							</div>
						</van-cell>
						<van-cell title="我的店铺" icon="hotel-o" is-link to="/idleNone">
							<div slot="icon" class="icon_img">
								<img src="../../assets/idleNone.png" alt="">
							</div>
						</van-cell>
						<van-cell title="我的合同" icon="edit" is-link to="/mycontract">
							<div slot="icon" class="icon_img">
								<img src="../../assets/bid.png" alt="">
							</div>
						</van-cell>
						<van-cell title="我要推广" icon="setting-o" is-link @click="setParams(userInfo.id)">
							<div slot="icon" class="icon_img">
								<img src="../../assets/tongzhi.png" alt="">
							</div>
						</van-cell>
						<van-cell title="我的方案" icon="setting-o" is-link to="/programme">
							<div slot="icon" class="icon_img">
								<img src="../../assets/programme.png" alt="">
							</div>
						</van-cell>
					</div>
					<div class="list-bottom">
						<van-cell title="关于我们" icon="hotel-o" is-link to="about">
							<div slot="icon" class="icon_img">
								<img src="../../assets/jbj.png" alt="">
							</div>
						</van-cell>
						<van-cell title="个人设置" icon="setting-o" is-link to="/seting">
							<div slot="icon" class="icon_img">
								<img src="../../assets/setting.png" alt="">
							</div>
						</van-cell>
					</div>
				</div>
			</div>
		</div>
		<MinBar></MinBar>
		<!-- 预览图 -->
		<van-image-preview v-model="userImg" :images="image"></van-image-preview>
		<!-- 开通会员 -->
		<van-popup v-model="show" position="bottom">
			<van-panel class="payment">
				<div slot="header" class="payment_header">
					<div class="header-type" :class="{'active': payType == 1}" @click="payType=1">
						<div>包年VIP</div>
						<div>¥680/年</div>
						<van-icon name="checked" size="1rem" v-if="payType == 1" color="#F1452F" />
					</div>
					<div class="header-type" :class="{'active': payType == 2}" @click="payType=2">
						<div>包月VIP</div>
						<div>¥88/月</div>
						<van-icon name="checked" size="1rem" v-if="payType == 2" color="#F1452F" />
					</div>
				</div>
				<div class="payment_content">
					<van-radio-group v-model="radio">
						<van-cell-group>
							<van-cell title="微信支付" clickable @click="radio='1'">
								<div slot="icon" class="payment_icon">
									<img src="../../assets/wx.png" alt="">
								</div>
								<van-radio checked-color="#F1452F" icon-size="1rem" slot="right-icon" name="1" />
							</van-cell>
							<van-cell title="支付宝支付" clickable @click="radio='2'">
								<div slot="icon" class="payment_icon">
									<img src="../../assets/zfb.png" alt="">
								</div>
								<van-radio checked-color="#F1452F" icon-size="1rem" slot="right-icon" name="2" />
							</van-cell>
						</van-cell-group>
					</van-radio-group>
					<div class="pays_btn">
						<button @click="submitPay">确定</button>
					</div>
				</div>
			</van-panel>
		</van-popup>
	</div>
</template>

<script>
	import Like from '@/components/like/like'
	import MinBar from '@/components/minBar'

	export default {
		name: 'min',
		data() {
			return {
				userInfo: {},
				userInfoo: {},
				order: [],
				show: false,
				userImg: false,
				image: [],
				radio: '1',
				payType: 1,
				newList: "",
				newxiaoxi: true,
				browse: 0,
				number: '',
			}
		},
		created() {
			this.getData();
			this.getsitearr();
			if (localStorage.getItem('styles') == 1) {
				localStorage.removeItem('styles');
				window.location.reload();
			}
		},
		methods: {
			// 获取线下订单数量
			getsitearr() {
				this.$axios.post(baseUrl + '/mobile/OfflineOrder/offlineOrder', {
					token: localStorage.getItem('Authorization')
				}).then((res) => {
					if (res.data.code == 2) {
						var states = 0;
						for (var i = 0; i < res.data.data.length; i++) {
							if (res.data.data[i].state == 0) {
								states++
							}
						}
						this.number = states;
					}
				}).catch(function(err) {
					console.log(err);
				});
			},
			getData() {
				this.$axios.post(baseUrl + "/mobile/Base/siteMsg", {
					token: localStorage.getItem('Authorization')
				}).then(res => {
					this.newList = res.data.data.new
				})
				this.$axios.post(baseUrl + '/mobile/User/userCollection', {
					token: localStorage.getItem('Authorization')
				}).then((res) => {
					if (res.data.code == 2) {
						this.userInfoo = res.data.data
					} else {
						this.back();
					}
				}).catch((err) => {
					console.log(err);
				});
				this.$axios.post(baseUrl + '/mobile/User/userInformation', {
					token: localStorage.getItem('Authorization')
				}).then((res) => {
					if (res.data.code == 2) {
						this.userInfo = res.data.data
					} else {
						this.back();
					}
				}).catch((err) => {
					console.log(err);
				});

				this.$axios.post(baseUrl + '/mobile/Order/userOrderCount', {
					token: localStorage.getItem('Authorization')
				}).then((res) => {
					if (res.data.code == 2) {
						this.order = res.data.data;
					}
				}).catch((err) => {
					console.log(err);
				});
				// 获取浏览记录数量
				this.$axios.post(baseUrl + "/mobile/Base/browseCount", {
					token: localStorage.getItem('Authorization')
				}).then(res => {
					this.browse = res.data.data
				})
			},
			to(path, index) {
				this.$router.push({
					path: path,
					query: {
						index: index
					}
				})
			},

			weidu() {
				this.newxiaoxi == false;
			},
			setParams(em) {
				this.$router.push({
					path: '/QRcode',
					query: {
						user_id: em
					}
				})
			},

			notice() {
				this.$toast('该功能暂未开通');
			},
			//预览图
			getImg(img, type) {
				this.userImg = true;
				this.image = [];
				this.image.push(baseUrl + '/uploads/' + img);
			},
			//确认支付
			submitPay() {
				this.$axios.post(baseUrl + '/mobile/UserVip/orderUserVip', {
					token: localStorage.getItem('Authorization'),
					is_channel: this.radio,
					vip_mode: this.payType
				}).then((res) => {
					if (res.data.code == 19) {
						if (this.radio == '1') {
							window.location.href = baseUrl + '/mobile/Pay/OrderUserVipWapWxPay?out_trade_no=' + res.data.data
							this.$router.push({
								path: '/min',
								query: {
									order_number: res.data.data
								}
							})
						} else {
							window.location.href = baseUrl + '/mobile/Pay/OrderUserVipWapPay?out_trade_no=' + res.data.data
							this.$router.push({
								path: '/min',
								query: {
									order_number: res.data.data
								}
							})
						}
					}
				}).catch((err) => {
					console.log(err);
				});
			}
		},
		components: {
			Like,
			MinBar
		}
	}
</script>

<style scoped>
	@import "min.css";

	.top-right a {
		color: #ffffff;

	}

	.top-right {
		position: relative;
	}

	.top-right .weidu {
		width: 0.3rem;
		height: 0.3rem;
		position: absolute;
		top: 12px;
		left: 16px;
		border-radius: 50%;
		background-color: #f00;
		border: 2px solid #fff;
	}

	.top-right div:nth-child(2) {
		position: relative;

	}

	.top-right div:nth-child(2) .van-icon {
		position: relative;
		top: 0.2rem;
	}

	.min .top .top-right span:nth-child(2) {
		position: relative;
	}

	.top-right div:nth-child(2) {
		margin-top: -0.08rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/min/min.vue